import HttpService from './http.service';

class ReportsService {
  getReport(params) {
    return HttpService.get('reports', { params })
      .then((res) => res.data);
  }
}

export default new ReportsService();
